import React from "react"
import { useScopeContextValue } from "@digits-shared/atoms/useScopeContextValue"
import useSession from "@digits-shared/hooks/useSession"
import { LegalEntityIdScope } from "src/frontend/components/LegalEntityIdScope"
import { useViewVersion } from "src/frontend/components/Shared/Contexts/useViewVersion"
import type FrontendSession from "src/frontend/session"

export const useBlockingViewVersion = () => {
  const viewVersion = useViewVersion()
  const legalEntityId = useScopeContextValue(LegalEntityIdScope)
  const { currentLegalEntityId } = useSession<FrontendSession>()

  const shouldProceed =
    legalEntityId &&
    legalEntityId === viewVersion?.legalEntityId &&
    legalEntityId === currentLegalEntityId

  return React.useMemo(() => {
    if (shouldProceed) {
      return viewVersion
    }

    return null
  }, [shouldProceed, viewVersion])
}
